/**
 * Компактная панель инструментов над блоковым layout страницы работы с задачей.
 * Все элементы управления редактором и запуском вынесены сюда.
 */
export default function WorkToolbar({
  connected,
  userCount,
  styleLintEnabled,
  onStyleLintChange,
  onFormatClick,
  formatting,
  inviteUrl,
  onCopyInvite,
  layoutEditMode,
  onLayoutEditModeChange,
  onLayoutPresetA,
  onLayoutPresetB,
  autoClearOutput,
  onAutoClearOutputChange,
  onClearOutput,
}) {
  return (
    <div className="work-toolbar">
      <div className="work-toolbar-left">
        <span className={`work-toolbar-indicator ${connected ? 'connected' : 'disconnected'}`} title={connected ? 'Подключено' : 'Отключено'}>
          {connected ? '🟢' : '🔴'}
        </span>
        <span className="work-toolbar-users" title={`Участников: ${userCount}`}>👥</span>
        <label className="work-toolbar-check">
          <input type="checkbox" checked={styleLintEnabled} onChange={(e) => onStyleLintChange?.(e.target.checked)} />
          <span>Линтер</span>
        </label>
        <button
          type="button"
          className="btn btn-small work-toolbar-btn"
          onClick={onFormatClick}
          disabled={formatting}
          title="Автоматически исправить отступы и пробелы (autopep8)"
        >
          {formatting ? '…' : 'формат'}
        </button>
        {inviteUrl != null && (
          <button type="button" className="btn btn-small work-toolbar-btn work-toolbar-icon" onClick={onCopyInvite} title="Ссылка на подключение">
            <i className="fa-solid fa-link ui-icon" aria-hidden />
          </button>
        )}
      </div>
      <div className="work-toolbar-right">
        <label className="work-toolbar-check">
          <input type="checkbox" checked={autoClearOutput} onChange={(e) => onAutoClearOutputChange?.(e.target.checked)} />
          <span>Очищать вывод при запуске</span>
        </label>
        <button type="button" className="btn btn-small work-toolbar-btn work-toolbar-icon" onClick={onClearOutput} title="Очистить вывод" aria-label="Очистить вывод">
          <i className="fa-solid fa-trash" aria-hidden />
        </button>
        <button
          type="button"
          className={`btn btn-small work-toolbar-btn ${layoutEditMode ? 'active' : ''}`}
          onClick={() => onLayoutEditModeChange?.(!layoutEditMode)}
          title="Режим настройки блоков (перетаскивание и изменение размеров)"
        >
          ⊞
        </button>
        <button type="button" className="btn btn-small work-toolbar-btn" onClick={onLayoutPresetA} title="Раскладка A">
          A
        </button>
        <button type="button" className="btn btn-small work-toolbar-btn" onClick={onLayoutPresetB} title="Раскладка B">
          B
        </button>
      </div>
    </div>
  );
}
